import {
  DEFAULT_DIR,
  DEFAULT_LANG,
  DEFAULT_THEME_MODE,
  NAV_TYPE_SIDE,
  SIDE_NAV_LIGHT,
} from "constants/ThemeConstant";
import { env } from "./EnvironmentConfig";

export const APP_NAME = "CAPMAS";
export const API_BASE_URL = env.API_ENDPOINT_URL;
export const WEBSITE_BASE_URL = env.WEBSITE_ENDPOINT_URL;
export const CHATBOT_BASE_URL = env.CHATBOT_URL;
// export const FRONT_END_URL = "https://capmas.achievo.app";
export const FRONT_END_URL = "http://new.capmas.gov.eg";
export const APP_PREFIX_PATH = "/admin";
export const AUTH_PREFIX_PATH = "/auth";

export const THEME_CONFIG = {
  navCollapsed: false,
  sideNavTheme: SIDE_NAV_LIGHT,
  locale: DEFAULT_LANG,
  navType: NAV_TYPE_SIDE,
  topNavColor: "#3e82f7",
  headerNavColor: "",
  mobileNav: false,
  currentTheme: DEFAULT_THEME_MODE,
  direction: DEFAULT_DIR,
};
